import React from 'react';
import { Link } from 'react-router-dom';
import './ContentListPage.css';
import SEO from './components/SEO';
import Breadcrumb from './components/Breadcrumb';

// 仮のコンテンツデータ（画像URLを追加）
const contents = [
  {
    id: 1,
    title: '転職者の本音！',
    description: '8割が応募したいと答える応募動機とは？',
    imageUrl: '/images/WP1.jpg', 
  },
  {
    id: 2,
    title: '面接官は"面接"が出来ているのか',
    description: '上場企業の面接官に聞いた面接の実態とは？',
    imageUrl: '/images/WP2.jpg',
  },
  // {
  //   id: 3,
  //   title: 'Content 2',
  //   description: 'This is the detail of content 2.',
  //   imageUrl: 'https://placekitten.com/200/200',
  // },
  // {
  //   id: 2,
  //   title: 'Content 2',
  //   description: 'This is the detail of content 2.',
  //   imageUrl: 'https://placekitten.com/200/200',
  // },
];

function ContentListPage() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'お役立ち資料', path: '/content' }
  ];

  return (
    <div className="content-list">
      <SEO page="content" />
      <section className="ds-page-hero">
        <div className="container">
          <Breadcrumb items={breadcrumbItems} />
          <p className="ds-eyebrow">RESOURCES</p>
          <h1 className="ds-h1">お役立ち資料</h1>
          <p className="ds-lead">
            採用・転職に関する最新の調査結果やノウハウをまとめた資料を無料でダウンロードいただけます。
          </p>
        </div>
      </section>

      <section className="ds-section ds-section--alt">
        <div className="container">
          <ul className="content-list-grid">
            {contents.map((content, index) => (
              <li key={content.id}>
                <Link to={`/content/${content.id}`} className="ds-card content-list-card">
                  <div className="content-list-thumb">
                    <img
                      src={content.imageUrl}
                      alt={content.title}
                      loading="lazy"
                    />
                  </div>
                  <div className="content-list-body">
                    <p className="content-list-num ds-num">{String(index + 1).padStart(2, '0')}</p>
                    <h2 className="ds-h3">{content.title}</h2>
                    <p className="content-list-text">{content.description}</p>
                    <span className="ds-link content-list-cta">資料をダウンロード</span>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}

export default ContentListPage;
